import React, { useEffect, useState } from "react";
import { SmartSoftButton, SmartTable, SmartTableNewInterface } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showNotification, showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import { ROLES_URLS } from "../../api/RolesUrls";
import CreateRole from "./CreateRole";
import { UsersTable } from "../Users";

const Roles = () => {
  const [data, setData] = useState([]);
  const [path, setPath] = useState("projects");
  const { setLoading, openModal } = useSiteContext();
  
  const loadTableData = (purpose = "") => {
    setLoading(true, purpose && purpose + "ing...");
    const subscription = get(ROLES_URLS.GET_ALL).subscribe((response) => {
      setData(response.data.data);
        purpose 
        ? setTimeout(() => setLoading(false), 800)
        : setLoading(false);
      });
    return () => subscription.unsubscribe();
  };

  useEffect(() => {
    loadTableData();
  },[]);

  const editRole = (id: string) => {
    setLoading(true);
    const subscription = post(ROLES_URLS.GET_ONE, { id: id }).subscribe((response) => {
      setLoading(false);
      openEditModal(response.data.data);
    });
    return () => subscription.unsubscribe();
  };

  const openEditModal = (data_in: any) => {
    let modalObject={
      title:"ROLE MODIFICATION",
      content:<CreateRole dataIn={data_in} loadTableData={loadTableData}/>,
      bodyClose: false,
    }
    openModal(modalObject)
  };


  const deteleRole = (obj: any) => {
    showYesOrNoAlert(`Do you want to Delete this "${obj["role_name"]}" Role?`, (result: string) => {
      if (result == "yes") {
        send_delete_request(obj);
      }},"question")    
  };

  const send_delete_request = (obj: any) =>{
    setLoading(true,"Deleting...");
    const subscription = post(ROLES_URLS.DELETE, { id: obj["ID"] }).subscribe((response) => {
      setLoading(false);
      showNotification("success", `${obj["role_name"]} Role Deleted Successfully`);
      loadTableData();
    });
    return () => subscription.unsubscribe();
  }


  const handleError =(msg: any)=>{
    setLoading(false) 
    showNotification("error",msg);
  } 

  const getUsersData = (obj: any) =>{
    setLoading(true);
    const subscription = post(ROLES_URLS.GET_USER_BY_ROLE,{id: obj["ID"],handleError}).subscribe((response) => {
      setLoading(false);
      openUsersModal(response.data.data, obj["role_name"])
    });
    return () => {
      subscription.unsubscribe();
    };
  }

  const openUsersModal = (dataIn: any, role_name: any) =>{
    let modalObject ={
      title: "ROLE : " +role_name ?? "User",
      content:<UsersTable dataIn={dataIn}/>,
      bodyClose: false,
      modalClass: "smart-modal-90",
    }
    openModal(modalObject)
  }

  const roles_details = (obj: any) => {
    return (
      <span className="icon" onClick={()=>getUsersData(obj)}>
        <i className="fa fa-angle-up"></i>
      </span>
    )
  }

  const getTop5Users=(obj: any)=>{
    const users = obj["users"];
    if(!users) return <div className="pl-6">-</div>
    if(!Array.isArray(users)) return users;

    return users.map((user, index)=>{
      if(index<5){
        return (
            <>
              <span>{user}</span>
              {users[index+1] && <span>{", "}</span>}
              {index==4 && users.length > 5 && <span>...</span>}
            </>
        )}
    })
  }

  const dateTime= (obj: any) =>{
    return obj["created_time"].split("T").join(" ");
  }

 const actionButtons= [
  {
    leftIcon: "fa-pencil", 
    type:"icon",
    classList:["has-text-link"],      
    onClick:(row:any)=> editRole(row["ID"])
  },
  {
    leftIcon: "fa-trash", 
    type:"icon",
    classList:["has-text-danger"],      
    onClick:(row:any)=> deteleRole(row)
  },
]

  const columns:SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5"},
    { title: "ROLES", index: "role_name"},
    { title: "USERS", index: "users", valueFunction: getTop5Users},
    { title: "CREATED TIME", index: "created_time", valueFunction: dateTime},
    { title: "DETAILS", index: "", valueFunction: roles_details, classHead:"has-text-centered", classBody:"has-text-centered"},
    { title: "", index: "action", type:"action", width: "5", buttons:actionButtons },
  ];

  const roleCreation= () =>{
    let modalObject={
      title:"ROLE CREATION",
      content: <CreateRole existRoles={data} loadTableData={loadTableData}/>,
      bodyClose: false
    } 
    openModal(modalObject)
  }

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="has-text-link is-size-4">Roles</p>,
     
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [       
        {
          type: "REFRESH",
          action:()=>loadTableData()          
        },    
      ],      
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "RIGHT",
    },
    
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align:"RIGHT",
      custom: 
        <div className="buttons mx-3">
          <SmartSoftButton 
            label="New Role" 
            onClick={()=>roleCreation()} 
            leftIcon="fa-plus"   
            classList={["smart-third-button"]}         
            />        
        </div>
    },
  ]

  const display_table = () =>(
    <div>
      <div className="shadow my-4">
        <SmartTable
          tableTop={tableTop}
          columns={columns}
          data={data}
          tableProps={{
            className: "table is-hoverable is-striped smart-pdf-table",
            isResponsive: true,
            searchIndexes: columns.map(item => item.index),
            searchPlaceHolder: "Search",
          }} 
      />
      </div>
    </div>
  )
  
  return (
    <div className="mb-6">
    {path=="projects" && display_table()}
    </div>
  );
};

export default Roles;
